let language = {
    CHECKOUT_PAYMENT_PRODUCTS: "产品",
    CHECKOUT_PAYMENT_IMPORT_SERVICE: "入口服务费",
    CHECKOUT_PAYMENT_QTY: "数量",
    CHECKOUT_PAYMENT_UNITED_PRICE: "单价",
    CHECKOUT_PAYMENT_PRICE: "总价",
    CHECKOUT_PAYMENT_PREVIEW: "预览",
    CHECKOUT_PAYMENT_PROJECT_NAME: "名字 :",
    CHECKOUT_PAYMENT_TAX: "税:",
    CHECKOUT_PAYMENT_SHIPPING: "运费:",
    CHECKOUT_PAYMENT_TOTAL_DUE: "总费用:",
    CHECKOUT_PAYMENT_TOTAL: "总费用:",
    CHECKOUT_PAYMENT_PAYMENT_METHOD: "支付方式:",
    CHECKOUT_PAYMENT_APPROVENOSECRET_DES: "为您的 {{website}} 帐户添加主要支付方式。这将是我们向您收取未来交易费用的默认方式。",
    CHECKOUT_PAYMENT_PAYPAL_DES: "PayPal 接受所有主要信用卡。您无需拥有 Paypal 帐户即可使用此付款方式。",
    CHECKOUT_PAYMENT_BANK_TRANSFER_DES: "若要付款，请点击\“{{payBtnText}}\”并按照转账指示进行操作。",
    CHECKOUT_PAYMENT_BACK_BTN: "后退",
    CHECKOUT_PAYMENT_BACK_PAYMENT: "支付",
    CHECKOUT_PAYMENT_CONFIRM_AND_PAY_BTN: "确认并付款",
    CHECKOUT_PAYMENT_COPYRIGHT_TIP: "我同意按照以下规定处理我的数据",

    // 订单支付方式不支持--提示
    CHECKOUT_PAYMENT_FAILED: "订单支付失败",
    CHECKOUT_PAYMENT_FAILED_DES1: "网站暂不支持该类型的支付方式，请重新选择订单支付类型后重试，或联系技术人员{{supportmail}}处理。",
    // 产品不支持预览提示
    CHECKOUT_PREVIEW_ISSUE_TITLE:"暂不支持预览",
    CHECKOUT_PREVIEW_ISSUE_CONTENT:"目前暂不支持未定制产品的预览功能。",
    // paypal重定向失败
    CHECKOUT_PAYMENT_ISSUE_TITLE:"PayPal 重定向失败",
    CHECKOUT_PAYMENT_ISSUE_CONTENT:"哦，PayPal 支付重定向失败，请稍后重试。",
}


export { language }